import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { PowerBankActionTypes } from "./constants";

// actions
import { PowerBankApiResponseSuccess, PowerBankApiResponseError, getPowerBanks } from "./actions";
import { addPowerBankAPI, deletePowerBankAPI, getAllPowerBanks, updatePowerBankAPI } from "../../helpers/api/powerbanks";

// GET_POWERBANKS
function* getPowerBanksSaga({ payload: { status, keyword } }: any): SagaIterator {
  try {
    const response = yield call(getAllPowerBanks, status, keyword);
    const data = response?.data?.data?.powerbanks;
    yield put(PowerBankApiResponseSuccess(PowerBankActionTypes.GET_POWERBANKS, data));
  } catch (error: any) {
    yield put(PowerBankApiResponseError(PowerBankActionTypes.GET_POWERBANKS, error));
  }
}

// ADD_POWERBANKS
function* addPowerBankSaga({ payload }: any): SagaIterator {
  try {
    const response = yield call(addPowerBankAPI, payload);
    const data = response?.data?.message;

    yield put(PowerBankApiResponseSuccess(PowerBankActionTypes.ADD_POWERBANKS, data));
    yield put(getPowerBanks("all"));
  } catch (error: any) {
    yield put(PowerBankApiResponseError(PowerBankActionTypes.ADD_POWERBANKS, error));
  }
}

// UPDATE_POWERBANKS
function* updatePowerBankSaga({ payload }: any): SagaIterator {
  try {
    const response = yield call(updatePowerBankAPI, payload.id, payload);
    const data = response?.data?.message;

    yield put(PowerBankApiResponseSuccess(PowerBankActionTypes.UPDATE_POWERBANKS, data));
    yield put(getPowerBanks("all"));
  } catch (error: any) {
    yield put(PowerBankApiResponseError(PowerBankActionTypes.UPDATE_POWERBANKS, error));
  }
}

// DELETE_POWERBANKS
function* deletePowerBankSaga({ payload: { id } }: any): SagaIterator {
  try {
    const response = yield call(deletePowerBankAPI, id);
    const data = response?.data?.message || { id };

    yield put(PowerBankApiResponseSuccess(PowerBankActionTypes.DELETE_POWERBANKS, data));
    yield put(getPowerBanks("all"));
  } catch (error: any) {
    yield put(PowerBankApiResponseError(PowerBankActionTypes.DELETE_POWERBANKS, error));
  }
}

// Watchers
function* watchGetPowerBanks() {
  yield takeEvery(PowerBankActionTypes.GET_POWERBANKS, getPowerBanksSaga);
}

function* watchAddPowerBank() {
  yield takeEvery(PowerBankActionTypes.ADD_POWERBANKS, addPowerBankSaga);
}

function* watchUpdatePowerBank() {
  yield takeEvery(PowerBankActionTypes.UPDATE_POWERBANKS, updatePowerBankSaga);
}

function* watchDeletePowerBank() {
  yield takeEvery(PowerBankActionTypes.DELETE_POWERBANKS, deletePowerBankSaga);
}

// Root saga
export default function* PowerBankSaga() {
  yield all([fork(watchGetPowerBanks), fork(watchAddPowerBank), fork(watchUpdatePowerBank), fork(watchDeletePowerBank)]);
}
